module.exports = __webpack_public_path__ + "media/images/users/registrations/flow-6-1e6c522ebe496bb97285563ef068de88.png";